module.exports = __webpack_public_path__ + "img/lordenl.f23da8cd.jpg";